module.exports = __webpack_public_path__ + "static/media/seth.6c424a37.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/bot_icons/seth.png
// module id = 116
// module chunks = 0